
export function hasClass(element, elementClass) {
  return element.className.includes(elementClass);
}

export function updateCalendarWidth(element) {
  const widthFixed = document.getElementById('calendar-card').offsetWidth;
  element.style.width = `${widthFixed}px`;
}

export function updateCalendarWidthWithClick() {
  return document.getElementById('calendar-card').offsetWidth;
}

function addClass(element, elementClass) {
  if (hasClass(element, elementClass)) {
    return false;
  }
  element.className = `${element.className} ${elementClass}`;
  return true;
}

function removeClass(element, elementClass) {
  if (!hasClass(element, elementClass)) {
    return false;
  }
  element.className = element.className.replace(` ${elementClass}`, '');
  return true;
}

export function scrolling() {
  const navBar = document.getElementById('top-nav-bar');
  const wrapper = document.getElementById('fixed-wrapper-js');
  const calendarElement = document.querySelector('.Calendar-Wrapper');
  if (wrapper === null || calendarElement === null) {
    return;
  }
  if (wrapper.getBoundingClientRect().top < navBar.getBoundingClientRect().bottom) {
    addClass(calendarElement, 'sticked');
    addClass(wrapper, 'withHeight');
    updateCalendarWidth(calendarElement);
  } else {
    removeClass(calendarElement, 'sticked');
    removeClass(wrapper, 'withHeight');
    updateCalendarWidth(calendarElement);
  }
}
